<div class="outsourced-maintenance-contract-container" *transloco="let t; prefix: 'maintenanceCosting'">
  <div class="filter-container d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-2">
      <h3 class="section-title">{{ t('outsourced.title') }}</h3>
    </div>

    <div class="filter-controls d-flex align-items-center gap-2">
      <div class="search-wrapper">
        <app-search
          [placeholder]="t('outsourced.searchPlaceholder')"
          [disabled]="isLoading"
          (searchTermUpdated)="onSearchTermUpdate($event)"
          [searchTerm]="searchTerm"
          [customWidth]="'385px'">
        </app-search>
      </div>

      <div class="dropdown-wrapper">
        <span ngbDropdown class="contract-type-filter" [autoClose]="true">
          <button
            type="button"
            class="btn contract-type-filter-btn form-control dropdown-toggle search-input"
            [disabled]="isLoading"
            id="contractTypeFilterDropdown"
            ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle">{{ contractTypeLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="contractTypeFilterDropdown">
            <div class="d-flex flex-column">
              <button class="btn btn-outline" (click)="onContractTypeFilter(contractTypeFilter.All)" ngbDropdownItem>
                {{ t('outsourced.filter.all') }}
              </button>
              <button class="btn btn-outline" (click)="onContractTypeFilter(contractTypeFilter.PerAssetContracts)" ngbDropdownItem>
                {{ t('outsourced.filter.perAssetContract') }}
              </button>
              <button class="btn btn-outline" (click)="onContractTypeFilter(contractTypeFilter.MultiAssetContracts)" ngbDropdownItem>
                {{ t('outsourced.filter.multiAssetContract') }}
              </button>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>

  <div class="table-container">
    <div class="table-inner">
      <div class="table-frame" [style.--visible-rows]="pageSize">
        <table class="contracts-table">
          <thead>
            <tr>
              @for(column of visibleColumns; track column.value) {
                <th [ngClass]="column.cssClass">{{ column.labelKey | transloco }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @if(isLoading) {
              <tr>
                <td [attr.colspan]="columnCount" class="loading-cell">
                  <div class="spinner-wrapper">
                    <div class="spinner-border"></div>
                  </div>
                </td>
              </tr>
            } @else {
              @if(!rows.length) {
                <tr>
                  <td [attr.colspan]="columnCount" class="empty-cell">
                    <app-empty-state></app-empty-state>
                  </td>
                </tr>
              }
              @for(row of rows; track row.index) {
                <tr class="contract-row">
                  @for(cell of row.cells; track cell.column.value) {
                    <td [ngClass]="cell.column.cssClass">
                      @if(cell.badgeClass !== null) {
                        <span class="contract-type-badge" [ngClass]="cell.badgeClass">
                          {{ cell.value }}
                        </span>
                      } @else {
                        {{ cell.value }}
                      }
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-footer d-flex justify-content-between align-items-center">
      @if(!isFullView && totalCount > previewPageSize) {
        <button class="btn view-all-btn" [disabled]="isLoading" (click)="onViewAll()">
          {{ t('shared.viewAll') }}
        </button>
      } @else if(isFullView) {
        <p class="pagination-text">
          {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
        </p>
      } @else {
        <div></div>
      }

      @if(isFullView) {
        <app-pagination
          [totalPages]="totalPages"
          [currentPage]="page"
          (pageChange)="goToPage($event)">
        </app-pagination>
      }

      <div></div>
    </div>
  </div>
</div>